import { TableRow, TableCell } from '@mui/material';

const DividerRow = ({ height }) => (
	<TableRow style={{ height: height }}>
		<TableCell style={{ padding: 0, border: 'none' }} />
	</TableRow>
);

export default DividerRow;
